import { render, staticRenderFns } from "./FormatListSelectorDialog.vue?vue&type=template&id=1a8259df&scoped=true&"
import script from "./FormatListSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./FormatListSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormatListSelectorDialog.vue?vue&type=style&index=0&id=1a8259df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8259df",
  null
  
)

export default component.exports